exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fp-kutu-kirmizi[data-v-186be5f7]{background-image:url(\"/src/assets/fingerprint-false.png\")}.fp-kutu-kirmizi[data-v-186be5f7],.fp-kutu-yesil[data-v-186be5f7]{width:50px;height:50px;position:absolute;cursor:pointer;text-align:center;font-size:18px;padding-top:10px;background-size:cover;z-index:999;color:#fff}.fp-kutu-yesil[data-v-186be5f7]{background-image:url(\"/src/assets/fingerprint-true.png\")}.customCard[data-v-186be5f7]{width:323px;height:204px;border-radius:10px;display:inline-block;border:2px solid #ccc;position:relative}.table>tbody>tr>td[data-v-186be5f7],.table>tbody>tr>th[data-v-186be5f7],.table>thead>tr>th[data-v-186be5f7]{align-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-186be5f7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/employees/Employees.vue
// module id = 300
// module chunks = 0